/**
 * Message types for the native controller.
 */
export const MESSAGE_TYPES = {
    MEETING_COMMAND: 'meetingCommand'
};
